module.exports = __webpack_public_path__ + "img/Cta.c5c77b97.png";